/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Run_LogsInputs */

const en_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run logs`)
};

const ar_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجلات التشغيل`)
};

const bn_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রান লগ`)
};

const de_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokolle ausführen`)
};

const es_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutar registros`)
};

const fr_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécuter les journaux`)
};

const pt_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executar registros`)
};

const zh_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行日志`)
};

const tr_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlükleri çalıştır`)
};

const ru_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журналы выполнения`)
};

const pl_svchip_run_logs = /** @type {(inputs: Svchip_Run_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uruchom dzienniki`)
};

/**
* | output |
* | --- |
* | "Run logs" |
*
* @param {Svchip_Run_LogsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_run_logs = /** @type {((inputs?: Svchip_Run_LogsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Run_LogsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_run_logs(inputs)
	if (locale === "bn") return bn_svchip_run_logs(inputs)
	if (locale === "de") return de_svchip_run_logs(inputs)
	if (locale === "es") return es_svchip_run_logs(inputs)
	if (locale === "fr") return fr_svchip_run_logs(inputs)
	if (locale === "pt") return pt_svchip_run_logs(inputs)
	if (locale === "zh") return zh_svchip_run_logs(inputs)
	if (locale === "tr") return tr_svchip_run_logs(inputs)
	if (locale === "ru") return ru_svchip_run_logs(inputs)
	if (locale === "pl") return pl_svchip_run_logs(inputs)
	return en_svchip_run_logs(inputs)
});